import PDFCard from './PDFCard';
import './styles.scss';

const PDFBox = ({ title, data }) => {
    return (
        <div className="box">
            <h3>{title}</h3>
            <div className="pdf-items">
                {data.map(el => (
                    <PDFCard key={el} title={el} />
                ))}
            </div>
        </div>
    );
};

export default PDFBox;
